export default __webpack_public_path__ + "static/media/tete29.72d6f6cc.png";